import { render, staticRenderFns } from "./BuildingsPage.vue?vue&type=template&id=13f395fb&scoped=true"
import script from "./BuildingsPage.vue?vue&type=script&lang=js"
export * from "./BuildingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f395fb",
  null
  
)

export default component.exports